import axios from 'axios';
import { GEARBOX_MODEL_DATA, MANUAL_DATA, ELECTRICAL_DATA, YOKE_DATA } from './Types'
import { toastr } from 'react-redux-toastr';

const headers = {
    'Content-Type': 'application/json',
    //Authorization:'Bearer 4lEZa54IiLSaAmloKW8YyBFpB5pX6dAqkKw3szUT8O8HaEgKB7G4LgbvYl9eBOu1e3tgvYOligAncfRb_4PUNwSrygdtmTvLdwMoJi5yQu9iIJAOu6J1U5iIKou92e9XLNAq953S1-R985Yc-BvLt9X9HJKYpgo4mu2DelbnHauQUdk-H-Rgv1umz56UhtnGcsPyzlHriGvJKhJjQtdPCA'
};

// const baseUrl = 'http://10.10.1.100:8089/api/v1';
// const baseUrl2 = 'http://10.10.1.100:8089/api/v1/';

const baseUrl = "https://jelapi.costitright.com/api/v1"
const baseUrl2 = "https://jelapi.costitright.com/api/v1/"

// const baseUrl = "http://10.10.1.100:10102/api/v1"
// const baseUrl2 = "http://10.10.1.100:10102/api/v1/"

export const getGearBoxModelData = (callBack) => {
    return dispatch => {
        const request = axios.get(`${baseUrl}/masters-gear-box/get-all`);
        request.then(res => {
            dispatch({
                type: GEARBOX_MODEL_DATA,
                payload: res
            })
            callBack(res)
        }).catch(err => {
            callBack(err)
        })
    }
}

export const getGearRatioData = (id, callBack) => {
    return dispatch => {
        const request = axios.get(`${baseUrl}/masters-gear-box/get-gear-ratio-out-put-flange-combo?gearBoxId=${id}`);
        request.then(res => {
            callBack(res)
        }).catch(err => {
            callBack(err)
        })
    }
}

export const getCalculationByGearRatio = (data, callBack) => {
    return dispatch => {
        const queryParams = `spindleDirection=${data.spindleDirection}&stemDiameter=${data.stemDiameter}&gearBoxModelDetailId=${data.gearBoxModelDetailId}`
        const request = axios.get(`${baseUrl}/masters-gear-box/get-calculation-by-gear-ratio?${queryParams}`);
        request.then(res => {
            callBack(res)
        }).catch(err => {
            callBack(err)
        })
    }
}

export function createShutterDesign(data, callback) {
    return (dispatch) => {
        const request = axios.post(`${baseUrl}/calculate-shutter-design/create`, data, headers);
        request.then((response) => {
            if (response.data.Result) {
                callback(response);
            } else {
                if (response.data.Message) {
                    toastr.error(response.data.Message);
                }
            }
        }).catch((error) => {
            callback(error);
        });
    };
}

export function updateShutterDesign(data, callback) {
    return (dispatch) => {
        const request = axios.put(`${baseUrl}/calculate-shutter-design/update`, data, headers);
        request.then((response) => {
            if (response.data.Result) {
                callback(response);
            }
        }).catch((error) => {
            callback(error);
        });
    };
}

export const getManualShutterData = (id, callBack) => {
    return dispatch => {
        const request = axios.get(`${baseUrl}/calculate-manual-operation/get-manual-operation-by-shutter-id/${id}`);
        request.then(res => {
            callBack(res)
            dispatch({
                type: MANUAL_DATA,
                payload: res.data.Data
            })
        }).catch(err => {
            callBack(err)
        })
    }
}

export const saveManualData = (data, callBack) => {
    return dispatch => {
        const request = axios.post(`${baseUrl2}calculate-manual-operation/create`, data);
        request.then(res => {
            callBack(res);
        }).catch(err => {
            callBack(err);
        })
    }
}

export function updateManualGate(data, callback) {
    return (dispatch) => {
        const request = axios.put(`${baseUrl}/calculate-manual-operation/update`, data, headers);
        request.then((response) => {
            if (response.data.Result) {
                callback(response);
            }
        }).catch((error) => {
            callback(error);
        });
    };
}

export const getElectricShutterData = (id, callBack) => {
    return dispatch => {
        const request = axios.get(`${baseUrl}/calculate-electrical-operation/get-electrical-operation-by-shutter-id/${id}`);
        request.then(res => {
            callBack(res)
            dispatch({
                type: ELECTRICAL_DATA,
                payload: res.data.Data
            })
        }).catch(err => {
            callBack(err)
        })
    }
}

export const saveElectricalData = (data, callBack) => {
    return dispatch => {
        const request = axios.post(`${baseUrl2}calculate-electrical-operation/create`, data);
        request.then(res => {
            callBack(res);
        }).catch(err => {
            callBack(err);
        })
    }
}

export function updateElectricGate(data, callback) {
    return (dispatch) => {
        const request = axios.put(`${baseUrl}/calculate-electrical-operation/update`, data, headers);
        request.then((response) => {
            if (response.data.Result) {
                callback(response);
            }
        }).catch((error) => {
            callback(error);
        });
    };
}

export const getAllShutterDesignDataList = (callBack) => {
    return dispatch => {
        const request = axios.get(`${baseUrl}/calculate-shutter-design/get-all-shutter-design`);
        request.then(res => {
            callBack(res)
        }).catch(err => {
            callBack(err)
        })
    }
}

export const filterShutterDesignData = (data, callBack) => {
    return dispatch => {
        const request = axios.post(`${baseUrl2}/calculate-shutter-design/get-by-search-shutter-design`, data);
        request.then(res => {
            callBack(res);
        }).catch(err => {
            callBack(err);
        })
    }
}

export const getShutterDesignData = (shutterId, callBack) => {
    return dispatch => {
        const request = axios.get(`${baseUrl}/calculate-shutter-design/get-shutter-design-calculation-by-id/${shutterId}`);
        request.then(res => {
            callBack(res)
        }).catch(err => {
            callBack(err)
        })
    }
}

export const setYokeDesignData = (data, callBack) => {
    return dispatch => {
        const request = axios.post(`${baseUrl}/calculate-yoke-design/create`, data)
        request.then(res => {
            callBack(res)
        }).catch(err => {
            callBack(err)
        })
    }
}

export const getYokeDesignData = (shutterId, callBack) => {
    return dispatch => {
        const request = axios.get(`${baseUrl}/calculate-yoke-design/get-yoke-design-by-shutter-id/${shutterId}`);
        request.then(res => {
            callBack(res)
            dispatch({
                type: YOKE_DATA,
                payload: res.data.Data
            })
        }).catch(err => {
            callBack(err)
        })
    }
}

export function updateYokeDesign(data, callback) {
    return (dispatch) => {
        const request = axios.put(`${baseUrl}/calculate-yoke-design/update`, data, headers);
        request.then((response) => {
            if (response.data.Result) {
                callback(response);
            }
        }).catch((error) => {
            callback(error);
        });
    };
}

export const getReport = (shutterId, callback) => {
    return (dispatch) => {
        const request = axios.get(`${baseUrl}/design-report/get-tender-vs-post-order-report/${shutterId}`, headers);
        request.then((response) => {
            callback(response);
        }).catch((error) => {
            callback(error);
        });
    };
}